<template>
    <div style="padding: 10px">
        <!--        <div style="font-size: 25px; color: #ffffff; padding: 20px 0px; text-align: center; background-color: #4294F7">-->
        <!--            <div style="font-size: 35px; margin-bottom: 10px">饿了么</div>-->
        <!--            <div><span style="color: #ffff00">抢66元</span>霸王餐红包</div>-->
        <!--            <div>点外卖<span style="color: #ffff00">先领红包</span></div>-->
        <!--            <van-button color="#F19554" round style="width: 110px; margin-top: 10px" @click="jumpToEleme">抢红包-->
        <!--            </van-button>-->
        <!--        </div>-->

        <div style="border-radius: 10px; box-shadow: 1px 1px 5px #999999">
            <Wp_image :url="eleme_img" radius="10px 10px 0px 0px"></Wp_image>
            <div style="display: flex">
<!--                <div class="button_class">-->
<!--                    -->
<!--                    <div v-if="!is_ready" @click="getElemeHb">小程序</div>-->
<!--                </div>-->
                <wx-open-launch-weapp v-if="is_ready" class="button_class" style="padding: 5px 0px; margin: 0px 5px"
                                      id="launch-btn"
                                      :username="wx_o_id"
                                      :path="wx_o_path_eleme"
                                      @ready="ready"
                >
                    <script type="text/wxtag-template">
                        <div style="font-size: 14px; text-align: center; padding: 10px 0px">
                            领红包
                        </div>
                    </script>
                </wx-open-launch-weapp>
                <div v-else class="button_class" @click="getElemeHb">小程序</div>

                <div v-if="hasshowAuthButton()" class="button_class" style="border-left: 1px solid #eeeeee" @click="clickToAuth">授权</div>
            </div>
        </div>
        <div v-if="hasshowAuthButton()" style="margin: 10px; color: #EE0A24; font-size: 15px">注：使用[饿了么]功能，第一次需要先授权</div>

        <div style="border-radius: 10px; box-shadow: 1px 1px 5px #999999; margin-top: 20px">
<!--            <wx-open-launch-weapp v-if="is_ready" class="button_class" style="padding: 5px 0px; margin: 0px 5px"-->
<!--                                  id="launch-btn"-->
<!--                                  :username="wx_o_id"-->
<!--                                  :path="wx_o_path_meituan"-->
<!--                                  @ready="ready"-->
<!--            >-->
<!--                <script type="text/wxtag-template">-->
<!--&lt;!&ndash;                    <Wp_image :url="meituan_img" radius="10px 10px 0px 0px"></Wp_image>&ndash;&gt;-->
<!--                    <img :src="meituan_img"/>-->
<!--                    <button>美团</button>-->
<!--                </script>-->
<!--            </wx-open-launch-weapp>-->



            <Wp_image :url="meituan_img" radius="10px 10px 0px 0px"></Wp_image>
            <div style="display: flex">
                <wx-open-launch-weapp v-if="is_ready" class="button_class" style="padding: 5px 0px; margin: 0px 5px"
                                      id="launch-btn"
                                      :username="wx_o_id"
                                      :path="wx_o_path_meituan"
                                      @ready="ready"
                >
                    <script type="text/wxtag-template">
                        <div style="font-size: 14px; text-align: center; padding: 10px 0px">
                            领红包
                        </div>
                    </script>
                </wx-open-launch-weapp>
                <div v-else class="button_class" @click="getElemeHb">小程序</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Wp_image from "../custom/Wp_image";
    import {Dialog} from "vant";

    export default {
        name: "Wp_waimai",
        components: {Wp_image},
        data() {
            return {
                wx_o_id: 'gh_8dc4eee090aa', //小程序原始id
                wx_o_path_eleme: 'pages/wp_jd/wp_eleme/wp_eleme.html',//要打开的小程序的页面，必须以“.html”结尾
                wx_o_path_meituan: 'pages/wp_jd/wp_meituan/wp_meituan.html',//要打开的小程序的页面，必须以“.html”结尾
                // wx_o_path: 'pages/wp_jd/wp_detail/wp_detail.html?skuId=54945059320',//要打开的小程序的页面，必须以“.html”结尾
                // wx_o_id: 'gh_98d94fb0908c',
                // wx_o_path: 'pages/index/index.html',
                eleme_img: '/images/eleme_share.jpg?t=' + new Date().getTime(),
                meituan_img: '/images/meituan_share.jpg?t=' + new Date().getTime(),
                is_ready: false,
            }
        },

        created() {
            this.initWxConfig();
        },

        mounted() {

        },

        methods: {
            ready(e) {
                // this.is_ready = true;
            },

            hasshowAuthButton(){
                if(this.$store.state && this.$store.state.taobao_pid){
                    return false;
                }else{
                    return true;
                }
            },

            initWxConfig() {
                let params = {
                    app_id: "wx441c534516758ef0",
                    noncestr: "1234qwer",
                    timestamp: new Date().getTime(),
                    url: window.location.href
                    // url: window.location.href.substring(0, window.location.href.indexOf('#'))
                };
                this.$getWxPublicSignature(params, response => {
                    if (response && response.code === 200) {
                        if (response.data) {
                            let _config = {
                                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                                appId: params.app_id, // 必填，公众号的唯一标识
                                timestamp: params.timestamp, // 必填，生成签名的时间戳
                                nonceStr: params.noncestr, // 必填，生成签名的随机串
                                signature: response.data,// 必填，签名
                                jsApiList: [''], // 必填，需要使用的JS接口列表
                                openTagList: ['wx-open-launch-weapp']
                            };
                            // this.$log(_config)
                            this.$wx.config(_config)
                            this.$wx.ready(()=>{
                                this.is_ready = true;
                            })
                        }
                    }
                })
            },

            getElemeHb() {
                Dialog.alert({
                    message: "请前往万品京选小程序进行后续操作"
                })
            },

            clickToAuth() {
                this.$router.push('/my?active=2')
            },

            getWxPublicSignature(fn) {
                // "app_id":"wx441c534516758ef0",
                //     "noncestr":"Wm3WZYTPz0wzccnW",
                //     "timestamp":"1595314132931",
                //     "url":"http://jd.wapg.cn/"
                let params = {
                    app_id: "wx441c534516758ef0",
                    noncestr: "1234qwer",
                    timestamp: new Date().getTime(),
                    url: window.location.href
                };
                this.$getWxPublicSignature(params, response => {
                    this.$log(response)
                    if (response && response.code === 200) {
                        if (response.data) {
                            if (fn) {
                                fn(response.data)
                            }
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .button_class {
        flex: 1;
        display: inline-block;
        text-align: center;
        padding: 15px 0px;
        font-size: 14px;
    }
    .button_hover_class{
        opacity: 0.1;
    }
</style>